export const Avatar = ({ user, size = "w-9 h-9", text = "text-sm", testid }) => {
  const name = user?.name || "?";
  const src = user?.photo_url ? `${process.env.REACT_APP_BACKEND_URL}${user.photo_url}` : null;
  if (src) {
    return <img src={src} alt={name} data-testid={testid} className={`${size} rounded-full object-cover shrink-0 bg-slate-100`} />;
  }
  return (
    <span data-testid={testid} className={`${size} rounded-full bg-primary/10 text-primary flex items-center justify-center font-bold ${text} shrink-0`}>
      {name[0]?.toUpperCase()}
    </span>
  );
};
